export const lang: any = {};